
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-d0189532\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CategorieModal.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CategorieModal.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d0189532\"}!../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./categorieModal.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/categories/CategorieModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CategorieModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d0189532", Component.options)
  } else {
    hotAPI.reload("data-v-d0189532", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/components/registration/categories/CategorieModal.vue
// module id = 1294
// module chunks = 0